export const has = (object, property) => Object.prototype.hasOwnProperty.call(object || {}, property);